/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Valid_EntryInputs */

const en_vault_valid_entry = /** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valid Entry`)
};

const es_vault_valid_entry = /** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrada Válida`)
};

const fr_vault_valid_entry = /** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrée valide`)
};

const de_vault_valid_entry = /** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gültiger Einlass`)
};

const id_vault_valid_entry = /** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entri Valid`)
};

/** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */
const ja_vault_valid_entry = en_vault_valid_entry;

/** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */
const zh_vault_valid_entry = en_vault_valid_entry;

/** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */
const ar_vault_valid_entry = en_vault_valid_entry;

/** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */
const it_vault_valid_entry = en_vault_valid_entry;

/** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */
const ru_vault_valid_entry = en_vault_valid_entry;

/** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */
const pt_vault_valid_entry = en_vault_valid_entry;

/** @type {(inputs: Vault_Valid_EntryInputs) => LocalizedString} */
const ko_vault_valid_entry = en_vault_valid_entry;

/**
* | output |
* | --- |
* | "Valid Entry" |
*
* @param {Vault_Valid_EntryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_valid_entry = /** @type {((inputs?: Vault_Valid_EntryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Valid_EntryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_valid_entry(inputs)
	if (locale === "es") return es_vault_valid_entry(inputs)
	if (locale === "fr") return fr_vault_valid_entry(inputs)
	if (locale === "de") return de_vault_valid_entry(inputs)
	if (locale === "ja") return ja_vault_valid_entry(inputs)
	if (locale === "zh") return zh_vault_valid_entry(inputs)
	if (locale === "ar") return ar_vault_valid_entry(inputs)
	if (locale === "id") return id_vault_valid_entry(inputs)
	if (locale === "it") return it_vault_valid_entry(inputs)
	if (locale === "ru") return ru_vault_valid_entry(inputs)
	if (locale === "pt") return pt_vault_valid_entry(inputs)
	return ko_vault_valid_entry(inputs)
});